module.exports = __webpack_public_path__ + "img/stage-2-animated.5a603a08.png";